<template>
  <a
    v-if="adviserEmail"
    :aria-label="`Contact adviser`"
    :href="`mailto:${adviserEmail}?subject=Contact%20My%20Adviser`"
    :title="`Contact adviser`"
    class="max-sm:w-full text-button2 font-semibold whitespace-nowrap"
    target="_blank"
    >Contact my adviser</a
  >
</template>
<script lang="ts" setup>
import { useSessionStore } from '@/store/pinia/SessionStore.ts'

const whitelabel = useSessionStore().getWhitelabelData
const adviserEmail = whitelabel?.adviser_contact_email
</script>
